if (!customElements.get('ns-packs-carousel')) {
  customElements.define('ns-packs-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-pack-slide]')];
      this.dots = [...this.querySelectorAll('[data-pack-dot]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dots.forEach((button, index) => button.addEventListener('click', () => { this.show(index); this.start(); }, { signal }));
      this.addEventListener('pointerdown', (event) => { this.pointerStart = { x: event.clientX, y: event.clientY }; }, { signal });
      this.addEventListener('pointerup', (event) => {
        if (!this.pointerStart) return;
        const x = event.clientX - this.pointerStart.x;
        const y = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.5) { this.show((this.index + (x < 0 ? 1 : this.slides.length - 1)) % this.slides.length); this.start(); }
      }, { signal });
      this.addEventListener('pointercancel', () => { this.pointerStart = null; }, { signal });
      this.addEventListener('focusin', () => this.stop(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => this.start()), { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.start(); }, { signal });
      this.start();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        slide.inert = i !== index;
        if (i === index) this.dots[i]?.setAttribute('aria-current', 'true');
        else this.dots[i]?.removeAttribute('aria-current');
      });
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.paused || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.interval) || 3000);
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
  });
}
